// Module
var code = "<script>let $ctrl</script> <molecule-form-drop-down-revised ng-if=\"$ctrl.countryListComplete\" options=\"$ctrl.countries\" model=\"$ctrl.model\" placeholder=\"{{ 'TR_110119-7444b4_TR' | translate }}\" callback-on-change=\"$ctrl.overviewLoad\" disabled=\"$ctrl.disabled\" required=\"$ctrl.required\"></molecule-form-drop-down-revised> ";
// Exports
module.exports = code;